// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qzOJ","left":"styles_left__36Woj"};